/**
 * Helper: Shopify
 * -----------------------------------------------------------------------------
 * Shopify helper functions.
 *
 */
import productByIdQuery from '~graphql/product-by-id.gql'
import productsByIdQuery from '~graphql/products-by-id.gql'

import { formatProduct } from '~/format/format-product'

/**
 * Performs a Shopify API call for localized product data.
 * @param {Array} ids - Shopify product ids.
 * @param {Boolean} [useCache] - Use cache.
 * @returns {Object}
 */
export async function shopifyProductsByIdQuery(ids, useCache = false) {
  let response = null

  try {
    response = await cnvs.Query({
      query: productsByIdQuery,
      variables: {
        country: cnvs.store.country,
        ids,
        language: cnvs.store.language,
      },
    }, useCache)

  } catch (event) {
    window.console.error('[Shopify] Error querying the Storefront API.', event)
  }

  return response?.nodes.filter((prod) => prod !== null).map(formatProduct)
}

/**
 * Performs a Shopify API call for localized product data.
 * @param {String} id - Shopify product id.
 * @param {Boolean} [useCache] - Use cache.
 * @returns {Object}
 */
export async function shopifyProductByIdQuery(id, useCache = false) {
  let response = null

  try {
    response = await cnvs.Query({
      query: productByIdQuery,
      variables: {
        country: cnvs.store.country,
        id,
        language: cnvs.store.language,
      },
    }, useCache)

  } catch (event) {
    window.console.error('[Shopify] Error querying the Storefront API.', event)
  }

  if (!response) {
    return false
  }

  return formatProduct(response)
}
